import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"
import {gql} from "@irati/utils/gql"

export const orderFiltersQuery = gql`
  query OrderFilters {
    orderFilters {
      organisation_approval
      status
      employee_numbers
      ni_numbers
      payroll_periods_by_frequency {
        frequency
        periods
      }
    }
  }
`

export const getOrderFiltersQueryKey = getQueryNames(orderFiltersQuery)[0]
